import { Theme } from '@mui/material';

export const getAutocompleteStyles = (theme: Theme) => ({
  '& .MuiAutocomplete-inputRoot': {
    padding: `${theme.backrs.spacing['spacing-none']} !important`,
    paddingLeft: theme.backrs.radius['radius-lg'] + ' !important',
    borderRadius: theme.backrs.radius['radius-md'],
    backgroundColor: theme.backrs.colors['Colors/Background/bg-primary'],
    border: `1px solid ${theme.backrs.colors['Colors/Foreground/fg-quaternary']}`,
    transition: 'all 0.3s ease-in-out',
    '&.Mui-disabled': {
      backgroundColor: theme.backrs.colors['Colors/Background/bg-disabled-subtle'],
      borderColor: theme.backrs.colors['Colors/Border/border-disabled'],
      boxShadow: 'none !important',
    },
    '&:hover': {
      border: `1px solid ${theme.backrs.colors['Colors/Foreground/fg-primary']}`,
      boxShadow: theme.backrs.shadows['shadow-lg'],
      '&.Mui-disabled': {
        boxShadow: 'none !important',
        borderColor: theme.backrs.colors['Colors/Border/border-disabled'],
        backgroundColor: theme.backrs.colors['Colors/Background/bg-disabled-subtle'],
      },
    },
    '&.Mui-focused': {
      paddingLeft: theme.backrs.radius['radius-lg'],
      outline: 'none',
      boxShadow: theme.backrs.shadows['shadow-lg'],
      border: `1px solid ${theme.backrs.colors['Colors/Foreground/fg-primary']}`,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
});

export const getAutocompletePaperStyles = (theme: Theme) => ({
  mt: theme.backrs.spacing['spacing-md'],
  boxShadow: theme.backrs.shadows['shadow-xl'],
  border: `1px solid ${theme.backrs.colors['Colors/Foreground/fg-primary']}`,
  borderRadius: theme.backrs.radius['radius-md'],
});
